import { getAuth, onAuthStateChanged } from "firebase/auth";
const { API_ROOT_URL } = require("../../../configs/activebuildconfig.json")

/**
 * CONTROLLER - create
 * FUNCTION - createDraftPuzzle
 * VERIFY - verified user
 * @param {*} puzzleData The data for the new puzzle
 * @param {*} callback callback function
 * @returns The puzzle data 
 */

export const createDraftPuzzle = async (puzzleData, callback) => {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken(false);
        const response = await fetch(`${API_ROOT_URL}/create/create_draft_puzzle`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                token,
                puzzleData
            }),
        })
        const result = await response.json();
        callback(result)
    })
}